<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex xs12 sm6 md12>
          <v-text-field label="Name" v-model="itemData.name"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field
            label="Guard"
            disabled
            v-model="itemData.guard_name"
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemData">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'

  export default {
    data () {
      return {
        resource: 'roles'
      }
    },
    mixins: [ dialogMixins ]
  }
</script>



// WEBPACK FOOTER //
// AppEditRolesDialog.vue?a7902c5e